import { render, staticRenderFns } from "./XIconParts.vue?vue&type=template&id=087814c0&scoped=true"
import script from "./XIconParts.vue?vue&type=script&lang=ts"
export * from "./XIconParts.vue?vue&type=script&lang=ts"
import style0 from "./XIconParts.vue?vue&type=style&index=0&id=087814c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087814c0",
  null
  
)

export default component.exports